export default [
  'Cat',
  'Dog'
]
